import React, { useState } from "react";
import classes from './PettyCash.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";

const PettyCash = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = [
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },
        { transaction: 'PC-002', discription: 'New Entries', categories: 'Travel', debit: '₦2000', recipt: 'Yes', date: '2025-01-15', type: 'Expense', balance: '₦8000'  },

    ];
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}
                    onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
                    <button className={classes.btns}
                    onClick={() => navigate('/inventory/purchaseOrder')}>Purchase Invoice</button>
                    <button className={classes.btns_Btns}>Petty Cash</button>
                    <button className={`${classes.btns} ${classes.greens}`}
                    onClick={() => navigate('/settings/product-services')}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Petty Cash Managements</h2>
                    <h1 className={classes.Titles}>
                        Manage your purchase transactions, supplier invoices, and payments.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Current Balance</p>
                                <p className={classes.kdptg1}>₦8,400,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Available Cash</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>This Month Expenses</p>
                                <p className={classes.kdptg2}>₦4,950,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Spent</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Replenishments</p>
                                <p className={classes.kdptg3}>₦3,200,000.000</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This Month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Transcations</p>
                                <p className={classes.kdptg4}>15</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This Month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search all entries" />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <div className={classes.btnsMain}>
                        <button className={classes.btnssWhite}> Replenish</button>
                        <button className={classes.btnss}> + New Expense</button>
                    </div>
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Transaction #</th>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Debit</th>
                                <th>Type</th>
                                <th>Balance</th>
                                <th>Receipt</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{row.transaction}</td>
                                    <td className={classes.tableCell}>{row.date}</td>
                                    <td className={classes.tableCell}>{row.discription}</td>
                                    <td className={classes.tableCell}>{row.categories}</td>
                                    <td style={{ textAlign: 'right' }}>{row.debit}</td>
                                    <td className={classes.tableCell}>{row.type}</td>
                                    <td style={{ textAlign: 'right' }}>{row.balance}</td>
                                    <td className={classes.tableCell}>{row.recipt}</td>

                                    {/* <td className={classes.tableCell}>{row.action}</td> */}
                                    {/* <td className={classes.tableCell}>{row.type}</td> */}
                                    <td className={classes.tableCell}>
                                        <div className={classes.actionIcons}>
                                            <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                                            <Edit size={16} style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)' }} />
                                            <Trash size={16} style={{ color: 'rgba(255, 2, 2)' }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

                    </tfoot>

                </table>
            </div>
            <Footer />

        </div>
    );
};

export default PettyCash;
